<div class="chat-phone" [class.chat-phone--locked]="locked">
  @if (showLabel) {
    <div class="chat-phone__label">
      What's the best contact number for {{ passengerName }}?
      @if (isMandatory) {
        <span class="chat-phone__required" aria-hidden="true">*</span>
      }
    </div>
  }

  @if (locked && chosenSummary === 'Skipped') {
    <div class="chat-phone__chosen">{{ chosenSummary }}</div>
  }

  @if (hasSavedNumbers) {
    <select
      class="chat-phone__control"
      aria-label="Saved numbers"
      [disabled]="locked"
      (change)="onDropdownChange($any($event.target).value)"
    >
      @for (saved of savedNumbers; track saved.id) {
        <option [value]="saved.id" [selected]="selectedId === idToString(saved.id)">
          {{ formatSavedNumber(saved) }}
        </option>
      }
      <option [value]="NONE_ID" [selected]="selectedId === NONE_ID">None</option>
    </select>
  }

  @if (showManualEntry) {
    <div class="chat-phone__manual">
      <select
        class="chat-phone__country"
        aria-label="Country code"
        [disabled]="locked"
        [(ngModel)]="countryCode"
      >
        <option [ngValue]="null">Code</option>
        @for (country of searchService.countries; track country.cCode) {
          <option [ngValue]="country.dCode">+{{ country.dCode }}</option>
        }
      </select>
      <input
        type="text"
        class="chat-phone__number"
        aria-label="Phone number"
        [disabled]="locked"
        [(ngModel)]="number"
        placeholder="7700 900000"
      />
    </div>
  }

  <div class="chat-phone__actions">
    @if (!isMandatory) {
      <button type="button" class="chat-phone__skip" [disabled]="locked" (click)="onSkip()">
        Skip
      </button>
    }
    <button
      type="button"
      class="chat-phone__continue"
      [disabled]="locked || !isValid"
      (click)="onContinue()"
    >
      Continue
    </button>
  </div>
</div>
